import { useSelector } from 'react-redux'
import { Loading } from '../../../../../common/loading'
import { Notification } from '../../../../../common/notification'
import { Layout } from '../../common/layout'
import { TitleChart } from '../../common/TitleChart'
import { Chart } from './Chart'
import {
  selectActiveRowGroupId,
  selectIds,
  selectIsLoading,
  selectRowGroup,
} from './store/slice'
import { EarningQualityTable } from './EarningQualityTable'

export const Content = () => {
  const activeRowGroupId = useSelector(selectActiveRowGroupId)
  const isLoading = useSelector(selectIsLoading)
  const ids = useSelector(selectIds)

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!ids.length) {
    return <Notification />
  }

  return (
    <Layout
      renderLeft={() => <EarningQualityTable />}
      renderRight={() => <Chart />}
      renderTitle={() => (
        <TitleChart
          rowGroupId={activeRowGroupId}
          selectRowGroup={selectRowGroup}
        />
      )}
    />
  )
}
